import React from 'react';

const formatNumber = (num: number): string => num.toString().padStart(2, '0');

export interface TimerCardProps {
    value: number;
    label: string;
    prevValue: number;
}

const TimerCard = ({ value, label, prevValue }: TimerCardProps) => {
    const isChanging = value !== prevValue;

    return (
        <div className="flex flex-col items-center min-w-[45px]">
            <div className="relative h-[45px] overflow-hidden mb-0"> {/* Adjusted height to fit number line-height */}
                <div key={value} className={`flex flex-col ${isChanging ? 'animate-scroll-up' : ''}`}>
                    {isChanging && (
                        <span className="font-montserrat text-[32px] font-bold leading-[1.4] tracking-[-0.02em] tabular-nums text-center text-white flex items-center justify-center">
                            {formatNumber(prevValue)}
                        </span>
                    )}
                    <span className="font-montserrat text-[32px] font-bold leading-[1.4] tracking-[-0.02em] tabular-nums text-center text-white flex items-center justify-center">
                        {formatNumber(value)}
                    </span>
                </div>
            </div>
            <span className="font-inter text-[14px] font-normal leading-[1.5] text-gray-200 text-center">
                {label}
            </span>
        </div>
    );
};

export default TimerCard;
